const validate = values => {
  const errors = {}

  if (!values.document_feature_form?.document) {
    errors.document_feature_form = {
      ...errors.document_feature_form,
      document: "The document is required!",
    }
  }

  if (!values.document_feature_form?.name) {
    errors.document_feature_form = {
      ...errors.document_feature_form,
      name: "The document name is required!",
    }
  }

  return errors
}

export default validate
